import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlaylist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlaylist"><Path d="M2.5 5.5H16.5M2.5 12H11.5M2.5 18.5H9.5M21.5 4.5V16.5M21.5 17C21.5 18.3807 19.933 19.5 18 19.5C16.067 19.5 14.5 18.3807 14.5 17C14.5 15.6193 16.067 14.5 18 14.5C19.933 14.5 21.5 15.6193 21.5 17Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlaylist;
